<template>
  <div class="home">
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'LogoutView',
  mounted() {
    localStorage.removeItem('admin');
    localStorage.removeItem('adminusername');
    localStorage.removeItem('adminname');
    localStorage.removeItem('adminid');
    console.log('successful logout');
    fetch(this.$host+'/logout', {
      method:'POST',
      credentials:'include',
      mode:'cors',
      headers: {'Content-type':'application/json'},
      body:'{}'
    }).then(res=>res.json()).then(res=>{
      console.log(res);
      this.$router.push('/login');
    });
  }
}
</script>
